module.exports = __webpack_public_path__ + "img/logo.735b562f.png";